
<div class="modal active AirspaceVertex">
  <div class="modal__container" style="width: 45%; top: 10%;">
    <div class="fields">
      <h2>Airspace Vertex Import Options</h2>
      <div class="close" (click)="cancelAirspaceVertex()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngAirspaceVertexForm" #ngForm="ngForm" id="airspaceVertexForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>Configured Fields To Import</h4>
                <span> </span>
              </div>
              <div class="table-fields">
                <div style="overflow-y: scroll; height: 237px;">
                  <table>
                    <caption>
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">Use</th>
                        <th scope="col">Name</th>
                        <th scope="col">Index</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr mdbTableCol *ngFor="let el of vertexImportCsvModel.table; let i = index">
                        <td>
                          <input id="chk_{{i}}" name="chk_{{i}}"
                           type="checkbox" [(ngModel)]="el.checked" [disabled]="el.required ? true : false"/>
                        </td>
                        <td>{{ el.name }}</td>
                        <td>
                          <input id="index_{{i}}" required="true"
                          name="index_{{i}}"
                          [(ngModel)]="el.index" value="el.index"/>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <br>
              <div class="input-fields">
                <div>
                  <label for="">Data Starting Line</label>
                  <input
                    maxlength="5"
                    [(ngModel)]="vertexImportCsvModel.dataStartingLine"
                    type="number"
                    name="dataStartingLine"
                    id="dataStartingLine"
                  />
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Field Separator</label>
                  <select name="Field Separator" id="fieldSeparator" [(ngModel)]="vertexImportCsvModel.fieldSeparator">
                    <option value=".">Dot (.)</option>
                    <option value=",">Comma (,)</option>
                    <option value=";">Semicolon (;)</option>
                    <option value="\t">Tab</option>
                    <option value=" ">Space</option>
                  </select>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Decimal Separator</label>
                  <select name="Decimal Separator" id="decimalSeparator" [(ngModel)]="vertexImportCsvModel.decimalSeparator">
                    <option value=".">Dot (.)</option>
                    <option value=",">Comma (,)</option>
                    <option value=";">Semicolon (;)</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>Data Source</h4>
                <span> </span>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">File Data Source</label>
                  <select name="Published" id="published" [(ngModel)]="vertexImportCsvModel.fileDataSource">
                    <option value="Published">Published</option>
                    <option value="User Defined">User Defined</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>CSV File Source</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">File Name</label>
                  <input
                  (change)="saveFile($event)"
                  style="padding-left: 0px;"
                  maxlength="300"
                  type="file"
                  name="filename"
                  id="filename"
                  [accept]="importFormat.fileExtension"
                  #uploadCsvFile
                />
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" [disabled]="!ngForm.form.valid" (click)="startImport()">
              OK
            </button>
            <button class="gray" (click)="cancelAirspaceVertex()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
